import { http } from "./api";

let cache = null;

export async function getSiteSettings(force = false) {
  if (cache && !force) return cache;
  try {
    const r = await http.get("/settings");
    cache = r.data || {};
  } catch {
    cache = {};
  }
  return cache;
}
